import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import { translate } from "@td/shared_utils";
import { Tooltip, AlertIcon, BellIcon, WarningIcon, Link } from "@td/ui";
import { activeToMaxPercentageRatio } from "../../utils";
import { NOTIFICATION_COLORS } from "../../constants"
import { useProviderPanels } from "../../contexts/provider-panels-context";

const MIN_NOTIFICATION_PERCENT = 70;
const MAX_NOTIFICATION_PERCENT = 100;
const NOTIFICATION_ICONS = {
  70: BellIcon,
  80: BellIcon,
  90: AlertIcon,
  100: WarningIcon,
};

const ActivePatientsLimit = React.memo(({ practiceTeamParticipant, provider }) => {
  const { providerPanelExtension } = practiceTeamParticipant;

  if (!providerPanelExtension) {
    return null;
  }

  const { specialtyCode  } = useProviderPanels();

  const { activeSize, maxSize} = providerPanelExtension;
  const { decimalPercent, exactPercent: percent } = activeToMaxPercentageRatio(activeSize, maxSize);
  const isBetweenMeasures = decimalPercent >= MIN_NOTIFICATION_PERCENT && decimalPercent <= MAX_NOTIFICATION_PERCENT;
  const isRestricted = activeSize === 0;
  const Icon = NOTIFICATION_ICONS[decimalPercent] || null;
  const color = NOTIFICATION_COLORS[decimalPercent] || null;
  const url = window.Routes.panel_path('patients', {
    providers: provider.id,
    practices: practiceTeamParticipant.practiceTeam.id,
    statuses: 'active',
    specialty: specialtyCode
  });

  const ActiveSizeComponent = () => (activeSize > 0) ? (
    <div
      className={styles.linkWrapper}
    >
      <Link
        href={url}
        restricted={isRestricted}
      >
        {activeSize}
      </Link>
    </div>
  ) : (activeSize);

  return (
    <React.Fragment>
      {isBetweenMeasures ? (
        <Tooltip
          title={translate(null, "provider_panel.list_view.active_patients_limit.tooltip", decimalPercent, { percent })}
        >
          <div
            className={styles.activePatientsLimit}
          >
           <ActiveSizeComponent />
            /
            <span
              style={{ color }}
            >
              {maxSize}
            </span>

            <Icon
              width={14}
              height={14}
              fill={color}
            />
          </div>
        </Tooltip>
      ) : (
        <div
          className={styles.activePatientsLimit}
        >
          <ActiveSizeComponent />
          <span>/</span>
          <span>{maxSize}</span>
        </div>
      )}
    </React.Fragment>
  );
});

ActivePatientsLimit.propTypes = {
  practiceTeamParticipant: PropTypes.object.isRequired,
  provider: PropTypes.object.isRequired,
};

ActivePatientsLimit.displayName = "ActivePatientsLimit";

export default ActivePatientsLimit;
